import {
  MutableRefObject,
  Dispatch,
  SetStateAction,
  ReactElement,
  useState,
} from 'react';
import { HashMap } from 'shared/types/commonView';
import { IssueFieldNames } from 'shared/domain/issueForm/types/fieldNames';
import { FieldOnView } from 'views/fieldsVisibility';
import { FieldVisibilityBox } from '../Box';

export function FieldWithState({
  field,
  settersRef,
  onChange,
  initialIsChecked,
  isChecked: controlledIsChecked,
  label,
  disabled,
  supportsDefaultDays,
  defaultDays,
  onDefaultDaysChange,
}: {
  field: FieldOnView;
  settersRef: MutableRefObject<HashMap<Dispatch<SetStateAction<boolean>>>>;
  onChange: (event: any, value: boolean) => void;
  initialIsChecked: boolean;
  isChecked?: boolean;
  label: string;
  disabled: boolean;
  supportsDefaultDays?: boolean;
  defaultDays?: number;
  onDefaultDaysChange?: (fieldName: IssueFieldNames, value: number | undefined) => void;
}): ReactElement {
  const [uncontrolledChecked, setUncontrolledChecked] =
    useState(initialIsChecked);
  settersRef.current[field.fieldName] = setUncontrolledChecked;
  const isChecked =
    controlledIsChecked !== undefined ? controlledIsChecked : uncontrolledChecked;
  return (
    <FieldVisibilityBox
      disabled={disabled}
      fieldName={field.fieldName}
      isChecked={isChecked}
      onChange={onChange}
      label={label}
      supportsDefaultDays={supportsDefaultDays}
      defaultDays={defaultDays}
      onDefaultDaysChange={onDefaultDaysChange}
    />
  );
}
